import actions from './brand/actions';
import reducer from './brand/reducer';

export {
  actions,
  reducer,
};
